'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/upload/style/css');

var _upload = require('antd/lib/upload');

var _upload2 = _interopRequireDefault(_upload);

var _css2 = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css3 = require('antd/lib/icon/style/css');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileUploader = function (_React$Component) {
  _inherits(FileUploader, _React$Component);

  function FileUploader(props) {
    _classCallCheck(this, FileUploader);

    var _this = _possibleConstructorReturn(this, (FileUploader.__proto__ || Object.getPrototypeOf(FileUploader)).call(this, props));

    _this.handleChange = function (_ref) {
      var file = _ref.file,
          fileList = _ref.fileList;

      if (file.status === 'done') {
        _this.handleUploadSuccess(file.response);
      }
      return _this.setState({ fileList: fileList });
    };

    _this.handleUploadSuccess = function (response) {
      var url = _this.props.uploadSign.host + '/' + _this.state.key;
      _this.setState({ url: url });
      _this.triggerChange(response.data.upload_id);
    };

    _this.triggerChange = function (url) {
      // Should provide an event to pass value to Form.
      var onChange = _this.props.onChange;
      if (onChange) {
        onChange(url);
      }
    };

    _this.state = {
      fileList: [],
      url: ''
    };
    return _this;
  }

  _createClass(FileUploader, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        key: '' + nextProps.uploadSign.dir + Date.now() + '.zip'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          token = _props.token,
          uploadSign = _props.uploadSign,
          fuckurl = _props.fuckurl;

      return _react2.default.createElement(
        _upload2.default,
        { name: 'file',
          action: uploadSign.host,
          accept: '.zip',
          listType: 'text',
          onChange: this.handleChange,
          defaultFileList: fuckurl && [{
            uid: -1,
            name: fuckurl.split('/').reverse()[0],
            status: 'done',
            url: fuckurl
          }],
          data: {
            key: this.state.key,
            OSSAccessKeyId: uploadSign.accessid,
            signature: uploadSign.signature,
            policy: uploadSign.policy,
            callback: uploadSign.callback
          },
          headers: {
            'Authorization': 'Bearer ' + token
          }
        },
        this.state.fileList.length >= 1 ? null : _react2.default.createElement(
          _button2.default,
          null,
          _react2.default.createElement(_icon2.default, { type: 'upload' }),
          '\u70B9\u51FB\u4E0A\u4F20\u6587\u4EF6'
        )
      );
    }
  }]);

  return FileUploader;
}(_react2.default.Component);

exports.default = FileUploader;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/file_uploader.js
// module id = 1344
// module chunks = 0